import React, { useEffect, useState } from 'react';
import { X, Printer } from 'lucide-react';
import QRCode from 'qrcode';
import { padQRCodeWithPrefix } from '@yawi/domain';
import { useI18n } from '@/shared/i18n';
import { Button } from '@/core/ui/components/Button';
import type { HouseholdMember, ResidenceInfo } from '@/shared/types';

interface MemberQRModalProps {
  member: HouseholdMember;
  residenceInfo?: ResidenceInfo;
  onClose: () => void;
}

export const MemberQRModal: React.FC<MemberQRModalProps> = ({ member, residenceInfo, onClose }) => {
  const { t } = useI18n();
  const [qrUrl, setQrUrl] = useState('');

  useEffect(() => {
    const generate = async () => {
      try {
        const url = await QRCode.toDataURL(padQRCodeWithPrefix('MEMBER-', String(member.id)), { width: 200, margin: 2 });
        setQrUrl(url);
      } catch (err) {
        console.error(err);
      }
    };
    generate();
  }, [member.id]);

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-slate-900/80 backdrop-blur-sm animate-in fade-in">
      <div className="bg-white w-full max-w-xs rounded-2xl p-6 text-center relative shadow-2xl">
        <button onClick={onClose} className="absolute top-4 right-4 text-slate-400"><X size={20} /></button>
        <h3 className="text-lg font-bold text-slate-800 mb-1">{member.name}</h3>
        <p className="text-xs text-slate-500 uppercase tracking-widest mb-6">{t(`profile.relation.${member.relation.toLowerCase()}` as any)}</p>

        <div className="bg-white p-2 border-4 border-slate-900 rounded-xl inline-block mb-6">
          {qrUrl ? (
            <img src={qrUrl} alt="QR" className="w-48 h-48" />
          ) : (
            <div className="w-48 h-48 bg-slate-100 animate-pulse rounded-lg" />
          )}
        </div>

        <p className="text-xs text-slate-400 mb-4">Acceso Permanente • Torre {residenceInfo?.tower}-{residenceInfo?.unit}</p>
        <Button className="w-full" onClick={() => window.print()} icon={<Printer size={16} />}>Imprimir Credencial</Button>
      </div>
    </div>
  );
};
